

'use strict';


// in favicons.php:
// <link rel="icon" href="<?php echo get_template_directory_uri() ?>/assets/favicons/favicon-light.ico" id="light_scheme_icon">
// <link rel="icon" href="<?php echo get_template_directory_uri() ?>/assets/favicons/favicon-dark.ico" id="dark_scheme_icon">

// the regular favicon.ico will be used for the admin



function set_favicon_according_to_scheme() {

  const lightSchemeIcon = document.querySelector('link#light_scheme_icon');
  const darkSchemeIcon = document.querySelector('link#dark_scheme_icon');
  
  function setLight() {
    document.head.append(lightSchemeIcon);
    if(darkSchemeIcon) {
      darkSchemeIcon.remove();
    }
  }

  function setDark() {
    document.head.append(darkSchemeIcon);
    if(lightSchemeIcon) {
      lightSchemeIcon.remove();
    }
  }


  const matcher = window.matchMedia('(prefers-color-scheme:dark)');

  function updateFaviconTheme() {
    // console.log('matcher', matcher)
    if (matcher.matches) {
      setDark();
    } else {
      setLight();
    }
  }
  // Listen for changes in color scheme
  matcher.addListener(updateFaviconTheme);

  updateFaviconTheme();
}

set_favicon_according_to_scheme();

